/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */

import { api } from 'utils/index';

const defaultState = { items: [], errors: null };

const model = {
    name: 'conversion',
    state: defaultState,
    reducers: {
        reset: state => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload }),
    },
    effects: {
        async fetch(params) {
            await api.get('conversions', params)
                .then(response => this.fetchResponse(response));
        },
    },
};

export default model;
